import { useEffect } from 'react';

export const useBodyScroll = (openModal) => {
  useEffect(() => {
    openModal && (document.body.style.overflow = 'hidden');
    !openModal && (document.body.style.overflow = 'unset');
  }, [openModal]);
};
